import React from "react";
import styled from "styled-components";

import {
    distances,
    globalMobileBreakpoint,
    palette,
} from "../../styles/constants";
import { cn } from "../../util/css";
import AppBarDinteroLogo from "./AppBarDinteroLogo";
import AppBarMerchantLogo from "./AppBarMerchantLogo";

type AppBarContainerProps = {
    children?: React.ReactNode;
    noInlinePadding?: boolean;
    placeholder?: boolean;
};

export const AppBarContainer = ({
    children,
    noInlinePadding,
    placeholder,
}: AppBarContainerProps) => {
    return (
        <>
            <AppBarBg
                className={cn(placeholder && "placeholder")}
                tabIndex={-1}
            >
                <AtTheTop
                    className={cn(placeholder && "placeholder")}
                    tabIndex={-1}
                >
                    {!placeholder && <AppBarMerchantLogo icon="profile" />}
                </AtTheTop>
                <ScrollableAppBarContainer tabIndex={-1}>
                    <AppBarContainerInner
                        className={cn(noInlinePadding && "no-inline-padding")}
                        tabIndex={-1}
                    >
                        {children}
                    </AppBarContainerInner>
                </ScrollableAppBarContainer>
                <AtTheBottom
                    className={cn(placeholder && "placeholder")}
                    tabIndex={-1}
                >
                    <AppBarDinteroLogo color="white" />
                </AtTheBottom>
            </AppBarBg>
        </>
    );
};

export const AppBarBg = styled.div`
    position: fixed;
    left: 0;
    height: 100vh;
    display: flex;
    flex-direction: column;
    z-index: 100;
    width: var(--navbar-width);
    border-right: 1px solid ${palette.darkmode[200]};
    background-color: ${palette.darkmode[400]};
    padding-bottom: 24px;
    overflow-x: hidden;


    scrollbar-width: none;

    @media (max-width: ${globalMobileBreakpoint}px) {
        display: none;
    }

    &.placeholder {}

`;

export const ScrollableAppBarContainer = styled.div`
    display: contents;

    @media (max-width: ${globalMobileBreakpoint}px) {
        width: 100%;
        min-width: 100%;
        overflow-x: overlay;
        z-index: 2;
        display: block;
        border-left: none;
    }
`;

export const AppBarContainerInner = styled.nav`
    height: 100%;
    align-self: flex-start;
    display: flex;
    flex-direction: row;
    z-index: 1;
    overflow-y: auto;
    transition: all 0.15s;
    padding-inline: 16px;
    position: relative;

    scrollbar-width: thin;
    scrollbar-color: ${palette.neutral[200]} transparent;

    overflow-x: hidden;

    &.collapsed {
        width: 56px;
        min-width: 56px;
        padding-inline: 0;
        .main-menu-wrapper {
            padding: 0;
            width: 100%;
        }
        .app-module-menu {
          button, a {
          padding: 0;
          }
          p {
          display: none;
          }
          .chevron {
          display: none;
          }
          .arrow-right-icon {
            display: none;
          }
          .icon {
          margin-right: 0;
          }
        }
    }

    @media (max-width: ${globalMobileBreakpoint}px) {
        min-height: auto;
        position: relative;
        flex-direction: row;
        justify-content: flex-start;
        z-index: 100;
        align-items: center;
        padding: 0;
        gap: ${distances.small};
        padding-inline: ${distances.small};
        width: 100%;
        min-width: max-content;
        border-bottom: 1px solid ${palette.neutral[200]};
        overflow-y: unset;
        overflow-x: unset;

        &.no-inline-padding {
            padding-inline: 0;
        }
    }

    width: var(--navbar-width);

    &::-webkit-scrollbar {
        width: 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${palette.neutral[200]};
        border-radius: 3px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
    }
`;

export const AtTheTop = styled.div`
    transition: all 0.15s;
    flex-grow: 99;

    @media (max-width: 768px) {
        display: none;
    }

    &.collapsed {
      .abml-appbar-icon-wrapper {
        width: 100%;
        justify-content: center;
        align-items: center;
        margin-inline: 0;
        margin-top: ${distances.tiny};
        div {
          margin: 0;
        }
      }
      .abml-text-wrapper {
        display: none;
      }
      .abml-arrow-up-down-icon {
        display: none;
      }
    }
`;

export const AtTheBottom = styled.div`
    transition: all 0.15s;
    position: fixed;
    padding-bottom: var(--Spacing-3);
    bottom: 0;
    width: calc(var(--navbar-width) - 1px);
    left: 0;
    z-index: 4;
    background: ${palette.darkmode[400]}aa;

    @media (max-width: 768px) {
        display: none;
    }

    &.placeholder {}
`;

export const Spacer = styled.div`
    padding-bottom: 16px;
`;
